module.exports = __webpack_public_path__ + "static/media/Matheus.ede818e7.jpg";